module.exports = __webpack_public_path__ + "img/265.685c1131.jpg";